export const getEmbedParams = async (url, pageName, visualName) => {
  if (!url) {
    return {};
  }
  if (pageName === undefined) {
    pageName = '';
  }
  if (visualName === undefined) {
    visualName = '';
  }
  return fetch(
    `/++api++/@powerbi?url=${url}&pageName=${pageName}&visualName=${visualName}`,
  ).then((r) => {
    if (!r.ok) {
      return {};
    }
    return r.json();
  });
};
